// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid_tOlIZ {
  display : grid;
  grid-template-columns: auto auto;
  grid-template-columns: auto auto;
  column-gap: var( --size-padMedium, 8px );
  row-gap: var( --size-padMedium, 8px );
  justify-items: stretch;
  align-items: center;
  margin-bottom : var( --size-padXLarge, 24xpx );
}

.metadata_Y50KZ {
  justify-self: right;
}
`, "",{"version":3,"sources":["webpack://./src/screens/oidc/OidcEditor.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gCAAgC;EAChC,gCAAgC;EAChC,wCAAwC;EACxC,qCAAqC;EACrC,sBAAsB;EACtB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".grid {\n  display : grid;\n  grid-template-columns: auto auto;\n  grid-template-columns: auto auto;\n  column-gap: var( --size-padMedium, 8px );\n  row-gap: var( --size-padMedium, 8px );\n  justify-items: stretch;\n  align-items: center;\n  margin-bottom : var( --size-padXLarge, 24xpx );\n}\n\n.metadata {\n  justify-self: right;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid": `grid_tOlIZ`,
	"metadata": `metadata_Y50KZ`
};
export default ___CSS_LOADER_EXPORT___;
